import { useParams, useSearchParams } from 'react-router-dom';

import { ContextNavigate } from '../../shared/components/context-navigate/context-navigate';
import { Documents } from '../containers/documents/documents';

export function DocumentRoute() {
    const { slug } = useParams();
    const [params] = useSearchParams();

    if (!slug) {
        return <ContextNavigate to="/404" />;
    }

    return <Documents slug={slug} version={params.get('version')} />;
}
